(function () {
  'use strict';

  var SECTION_ID = 'sepia-kintsugi-new-products';

  var products = [
    {
      name: 'Sepia KINTSUGIリングⅠ',
      price: '¥74,800',
      image:
        'https://milamorejewelry.com/cdn/shop/files/Base_3_RE_kokuin_RE.jpg?v=1783666430',
      link:
        'https://milamorejewelry.com/products/sepia-kintsugiring-1'
    },
    {
      name: 'Sepia KINTSUGIリングⅡ',
      price: '¥85,800',
      image:
        'https://milamorejewelry.com/cdn/shop/files/Base_7_RE_kokuin_RE.jpg?v=1783666435',
      link:
        'https://milamorejewelry.com/products/sepia-kintsugiring%E2%85%B1'
    },
    {
      name: 'Sepia KINTSUGIヴィクトリアリング',
      price: '¥95,700',
      image:
        'https://milamorejewelry.com/cdn/shop/files/Base_11_RE_kokuin_RE.jpg?v=1783666440',
      link:
        'https://milamorejewelry.com/products/sepia-kintsugivictoriaring'
    }
  ];

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function createProductCard(product) {
    return [
      '<article class="sepia-v2__card">',
        '<a class="sepia-v2__link" href="',
          escapeHtml(product.link),
        '">',

          '<div class="sepia-v2__image-wrap">',
            '<img',
              ' class="sepia-v2__image"',
              ' src="', escapeHtml(product.image), '"',
              ' alt="', escapeHtml(product.name), '"',
              ' width="1200"',
              ' height="1200"',
              ' loading="lazy"',
            '>',
          '</div>',

          '<div class="sepia-v2__content">',
            '<h3 class="sepia-v2__name">',
              escapeHtml(product.name),
            '</h3>',

            '<p class="sepia-v2__price">',
              escapeHtml(product.price),
            '</p>',

            '<span class="sepia-v2__cta">',
              '商品を見る',
            '</span>',
          '</div>',

        '</a>',
      '</article>'
    ].join('');
  }

  function createSection() {
    var section = document.createElement('section');

    section.id = SECTION_ID;
    section.setAttribute(
      'aria-label',
      'Sepia KINTSUGI Collection'
    );

    section.innerHTML = [
      '<div class="sepia-v2__inner">',

        '<header class="sepia-v2__header">',
          '<p class="sepia-v2__label">',
            'NEW COLLECTION',
          '</p>',

          '<h2 class="sepia-v2__title">',
            'Sepia KINTSUGI',
          '</h2>',

          '<p class="sepia-v2__intro">',
            '記憶は、セピアに変わる。',
          '</p>',
        '</header>',

        '<div class="sepia-v2__grid">',
          products.map(createProductCard).join(''),
        '</div>',

      '</div>'
    ].join('');

    return section;
  }

  function mountSection() {
    var productsSection =
      document.getElementById('products');

    if (
      !productsSection ||
      !productsSection.parentNode
    ) {
      return false;
    }

    var sepiaSection =
      document.getElementById(SECTION_ID);

    if (!sepiaSection) {
      sepiaSection = createSection();
    }

    if (
      sepiaSection.nextElementSibling !==
      productsSection
    ) {
      productsSection.parentNode.insertBefore(
        sepiaSection,
        productsSection
      );
    }

    return true;
  }

  function start() {
    if (mountSection()) {
      return;
    }

    var root =
      document.getElementById('kintsugi-root');

    if (!root) {
      return;
    }

    var observer = null;
    var attempts = 0;

    function stop() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        if (mountSection()) {
          window.setTimeout(stop, 3000);
        }
      });

      observer.observe(root, {
        childList: true,
        subtree: true
      });
    }

    var timer = window.setInterval(function () {
      attempts += 1;

      if (mountSection() || attempts >= 100) {
        window.clearInterval(timer);

        if (attempts >= 100) {
          stop();
        }
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();